import React from "react";
import { useDispatch } from "react-redux";
import { loadAuthenticationInfos } from "redux/authenticationInfos/authenticationInfoFunctions";
import { Grid, useMediaQuery } from "@material-ui/core";
import BankList from "components/BankList";
import Background from "img/Background.png";
import LoginHeader from "components/LoginHeader";
import { useLocation } from "react-router-dom";
import Error from "./Error";
import { getCurrentYear } from "utility/date";

const Login = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const matchesMediaQuery = useMediaQuery("(min-width: 600px)");

  React.useEffect(() => {
    dispatch(loadAuthenticationInfos());
  }, [dispatch]);

  const mobileHeight = location.pathname !== "/login" ? "100%" : "fit-content";

  return (
    <div
      style={{
        backgroundImage: `url(${Background})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        width: "100%",
        minHeight: matchesMediaQuery ? "100%" : mobileHeight,
      }}
    >
      <LoginHeader />
      {location.pathname === "/login" ? <BankList /> : <Error />}
      <Grid
        container
        style={{
          height: 47,
          background: "#1A1A1A",
        }}
      >
        <Grid
          item
          xs={12}
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            style={{
              color: "#666666",
              textAlign: "center",
              fontSize: "min(max(.7em, 3vw), 1em)",
              margin: 0,
            }}
          >
            © {getCurrentYear()} Forea Capital Oy. All rights reserved.
            {matchesMediaQuery ? " | " : <br />}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://forea.fi/wp-content/uploads/BEST-EXECUTION-2019.pdf"
              style={{ color: "#666666", textDecoration: "none" }}
            >
              Best Execution (in Finnish){" "}
            </a>{" "}
            |{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://forea.fi/wp-content/uploads/Tietoja-ForeaCapitalOy.pdf"
              style={{ color: "#666666", textDecoration: "none" }}
            >
              Customer Information (in Finnish){" "}
            </a>
          </p>
        </Grid>
      </Grid>
    </div>
  );
};

export default React.memo(Login);
